export default {"src":"/_next/static/media/ic_new_tooltip.9366fbe9.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};